import { useHistory, useParams } from "react-router";
import { useMemo } from "react";
import { SpaceAwareNavigation } from "./SpaceAwareNavigation";

export function useSpaceAwareNavigation() {
    const history = useHistory();
    const params = useParams<{ spaceId: string | undefined }>();
    return new SpaceAwareNavigation(history, params.spaceId);
}
